export default __webpack_public_path__ + "static/media/close.d05294f5.svg";